import * as Helper from '../helpers/helper';
import axios from 'axios';
import FilterParamsManager from './filterParamsManager';

export default class LoadResults extends FilterParamsManager {
    constructor(map) {
        super();
        this.eventCards = document.getElementsByClassName('event-card');
        this.mapContainer= document.querySelector('.map-container');
        this.map = map;
        this.loadTimeout;
        this.hoverListeners = [];
        this.page = 1;
        if (document.getElementById('map')) {

            this.onZoneSearch(true);
            document.addEventListener('map_changes', () => {
                this.onZoneSearch(false);
            });
            document.addEventListener('map_closes', () => {
                this.blockLocObserverOnetime = false;
                this.cancellationTokens.forEach((source) => {
                    source.cancel('Request cancelled');
                });
                // Clear the array of cancellation tokens
                this.cancellationTokens.length = 0;
                this.initEvents();
                this.reloadData = true;
                this.page = 1;
                this.updateData();
            });
        }
    }

    onZoneSearch(reload) {
        this.page = 1;
        if (!this.mapContainer.classList.contains('open') || this.map.inResultMove) {
            return;
        }
        clearTimeout(this.loadTimeout);
        this.loadTimeout = setTimeout(() => {
            this.blockLocObserverOnetime = true;
            this.setParams();

            // get viewport
            const currentMapSize = this.map.getCurrentMapSize();
            this.params.set('b_lng', currentMapSize[0]);
            this.params.set('b_lat', currentMapSize[1]);
            this.params.set('t_lng', currentMapSize[2]);
            this.params.set('t_lat', currentMapSize[3]);
            this.params.set('mode_map', true);
            this.params.set('page', 1);
            this.params.set('limit', 50);
            this.reloadData = reload;

            this.map.destroySlider();

            this.cancellationTokens.forEach((source) => {
                source.cancel('Request cancelled');
            });
            // Clear the array of cancellation tokens
            this.cancellationTokens.length = 0;

            this.updateData();
        }, 200);
    }

    updateData() {
        const lang = Helper.getCurrentLang();
        this.dataWrapper.classList.remove('got-result');
        this.ikeLoader.style.display = 'block';
        if (this.reloadData) {
            this.page = 1;
            this.dataWrapper.style.display = 'none';
            const noresult = document.getElementsByClassName('search-no-result')[0];
            if (noresult) {
                noresult.remove();
            }
        }

        this.pushSearchGTM();
        // debugger;

        const source = axios.CancelToken.source();
        this.cancellationTokens.push(source);

        const data = {};
        for (const [key, value] of this.params.entries()) {
            data[key] = key === 'mode_map' ? value === 'true' : value;
        }
        if (this.params.get('mode_map') === 'true') {
            data['loadedIds'] = this.map.data.map(item => item.id);
        }
        if (this.params.get('time_period') && this.page > 1) {
            data['last_date'] = document.querySelector('.event-card:last-child')?.getAttribute('data-date')
        }
        axios.post(`/${lang}/load-results`, data, {cancelToken: source.token})
            .then((response) => {
                // handle success
                this.hasMore = response.data.has_more;
                this.map.updateMapData(response.data.lngLat, this.reloadData, !this.params.has('t_lng'));
                this.params.delete('limit');

                this.ikeLoader.style.display = 'none';

                if(!window.matchMedia('(max-width: 800px)').matches) {
                    this.dataWrapper.style.display = 'flex';
                } else {
                    this.dataWrapper.style.display = '';
                    this.dataWrapper.classList.add('got-result');
                }

                this.dataWrapper.innerHTML = (this.reloadData ? '' : this.dataWrapper.innerHTML) + response.data.html;

                this.lazyLoading.lazyLoading();
                const header = document.getElementsByClassName('header-with-img')[0];
                if (header && response.data.bck_url) {
                    let headerWithTransition = header.cloneNode();
                    headerWithTransition.classList.add('header-background-transition');
                    header.insertAdjacentElement('afterend', headerWithTransition);
                    header.style.backgroundImage = `url('${response.data.bck_url}')`;
                    requestAnimationFrame(() => {
                        headerWithTransition.style.opacity = '0';
                    });
                    setTimeout(() => {
                        headerWithTransition.remove();
                    }, 1000);
                    this.lazyLoading.lazyLoading('.header-with-img');
                }
                const headerTitle = document.getElementsByClassName('title-hero')[0];
                if (headerTitle && response.data.title) {
                    headerTitle.innerHTML = response.data.title;
                }
                const breadcrumb = document.getElementsByClassName('breadcrumb-trail')[0];
                if (breadcrumb && response.data.breadcrumb) {
                    breadcrumb.innerHTML = response.data.breadcrumb;
                }

                if (document.getElementsByClassName('search-input')[0] && data['q'] !== undefined) {
                    document.getElementsByClassName('search-input')[0].value = data['q'];
                }

                if (document.getElementsByClassName('search-no-result')[0]) {
                    const resetButton = document.getElementById('reset-all-button');
                    if(resetButton) {
                        resetButton.addEventListener('click', (e) => {
                            e.preventDefault();
                            document.getElementsByClassName('search-input')[0].value = '';
                            this.resetFilters(true);
                        }, {once: true});
                    }
                }
              if (document.getElementsByClassName('search-suggest-title')[0]) {
                if(response.data.matched_word.value && response.data.matched_word.value != ""){
                  document.getElementsByClassName('search-suggest-title')[0].innerHTML = `
                    <span>${window.jsTranslations['suggest_search']}</span> <a href="${response.data.matched_word.url}">${response.data.matched_word.value}</a>
                  `;
                } else {
                  document.getElementsByClassName('search-suggest-title')[0].innerHTML = "";
                }
              }

              if (this.hasMore && this.params.get('mode_map') === 'true' && this.page < 5) {
                  this.page++;
                  this.params.set('page', this.page);
                  this.reloadData = false;
                  this.updateData();
              }
            })
            .catch((error) => {
                if (axios.isCancel(error)) {
                    console.log(error.message);
                } else if (error.response?.status == 429) {
                    this.hasMore = false;

                    if(!window.matchMedia('(max-width: 800px)').matches) {
                        this.dataWrapper.style.display = 'flex';
                    }
                    else {
                        this.dataWrapper.style.display = '';
                        this.dataWrapper.classList.add('got-result');
                    }
                    this.ikeLoader.style.display = 'none';
                    this.dataWrapper.innerHTML = error.response.data.html;
                }
            })
            .finally(() => {
                this.loader = false;
            });
    }

    pushSearchGTM() {
        document.dispatchEvent(new CustomEvent('ike_search', {
            detail: {
                searchTerm: this.params.toString()
            }
        }))
    }
}
